export type QueryLane = 'NEW' | 'QUOTATION SHARED' | 'BOOKED' | 'CLOSED';

export const QUERY_LANE_LABELS: Record<QueryLane, string> = {
  NEW: 'New',
  'QUOTATION SHARED': 'Quotation shared',
  BOOKED: 'Booked',
  CLOSED: 'Closed',
};

const normalizeStatusToken = (value?: string) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z]/g, '');

export const getQueryLane = (value?: string): QueryLane => {
  const token = normalizeStatusToken(value);
  if (['booked', 'booking', 'confirmed'].includes(token)) return 'BOOKED';
  if (['closed', 'cancelled', 'canceled', 'done'].includes(token)) return 'CLOSED';
  if (token === 'quotationshared' || token === 'sharedquotation') return 'QUOTATION SHARED';
  return 'NEW';
};

export const getQueryStatusLabel = (value?: string): string => QUERY_LANE_LABELS[getQueryLane(value)];

export const getQueryStatusValueForLane = (lane: QueryLane): string => QUERY_LANE_LABELS[lane];

export const getQueryStatusClassName = (value?: string): string => {
  const lane = getQueryLane(value);
  if (lane === 'QUOTATION SHARED') return 'quotation-shared';
  return lane.toLowerCase().replace(/\s+/g, '-');
};

export const isBookedQueryStatus = (value?: string): boolean => getQueryLane(value) === 'BOOKED';

export const isClosedQueryStatus = (value?: string): boolean => getQueryLane(value) === 'CLOSED';
